import { ArrayUtils } from '@colonist/utils';
import { OnlineStatus } from '../../../../../shared/friends/FriendTypes.ts';
import { createDivIn, createSpanIn, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { UIRoomFriendView } from './UIRoomFriendView.ts';
import { clientI18n } from '../../ClientI18n.ts';
import { UIUtilsFriends } from '../../ui_friends/UIUtilsFriends.ts';
import { ClientUserState } from '../../ClientUserState.ts';
import { ViewPopupLogin } from '../../ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
export class UIRoomFriendListController {
    // eslint-disable-next-line class-methods-use-this
    setRoomId(roomId) {
        return;
    }
    updateRoomState(roomState) {
        this.removeFriendsInSameRoom(roomState.getUserIds());
        this.isRoomFull = roomState.getSessionCount() >= roomState.gameSetting.maxPlayers;
        this.updateFriendsList(this.friendList);
    }
    removeFriendsInSameRoom(usersInRoom) {
        for (const friend of this.friendViews){
            const isFriendInRoom = usersInRoom.includes(friend.getUserId());
            if (isFriendInRoom) this.removeFriendView(friend);
        }
        this.usersInRoom = usersInRoom;
    }
    async getAllFriendCount() {
        var _ClientUserState_userState;
        const isNotLoggedIn = !((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn);
        if (isNotLoggedIn) {
            this.allFriendCount = 0;
            this.updateHeaderView(0);
            return;
        }
        const allFriends = await UIUtilsFriends.getFriends(ClientUserState.userState);
        this.allFriendCount = allFriends.friends.length;
        const onlineFriends = this.friendList.filter((friend)=>friend.onlineStatus != OnlineStatus.Offline).length;
        this.updateHeaderView(onlineFriends);
    }
    showFriendListUI() {
        var _ClientUserState_userState, _this_friendListContainer_querySelector;
        this.friendPlayerList.classList.add('shorten');
        this.friendListContainer.classList.remove('hidden');
        this.friendHeader.classList.remove('hidden');
        const isNotLoggedIn = !((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn);
        (_this_friendListContainer_querySelector = this.friendListContainer.querySelector('.room_friend_container')) === null || _this_friendListContainer_querySelector === void 0 ? void 0 : _this_friendListContainer_querySelector.remove();
        this.emptyFriendMessage = undefined;
        if (isNotLoggedIn) return this.createLoginToAddFriendsMessage();
        this.toggleEmptyFriendMessage(true);
    }
    updateHeaderView(onlineFriendCount) {
        const newText = clientI18n.t('strings:roomPage.friendsCount', {
            count: onlineFriendCount,
            maxCount: this.allFriendCount
        });
        if (this.friendHeader.innerText != newText) this.friendHeader.innerText = newText;
    }
    updateFriendsList(friends) {
        var _ClientUserState_userState;
        const isLoggedIn = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn;
        if (!isLoggedIn) return;
        this.friendList = friends;
        for (const friend of this.friendViews)friend.remove();
        this.friendViews.length = 0;
        if (this.isRoomFull) return this.toggleRoomFullMessage(true);
        const filteredFriendList = friends.filter((friend)=>!this.usersInRoom.includes(friend.userId));
        if (filteredFriendList.length == 0) return this.toggleEmptyFriendMessage(true);
        for (const friend of filteredFriendList)this.addFriendView(friend);
    }
    updateFriendOnlineStatus(friendData) {
        const friend = this.friendViews.find((friendView)=>friendView.getUserId() == friendData.userId);
        const isNewStatusOffline = friendData.onlineStatus == OnlineStatus.Offline;
        const friendNotInOnlineFriendsList = !friend;
        this.deleteRemovalTimeout(friendData.userId);
        if (friendNotInOnlineFriendsList && !isNewStatusOffline) return this.addFriendView(friendData);
        if (friendNotInOnlineFriendsList) return;
        if (isNewStatusOffline) return this.removeFriendViewWithDelay(friend, friendData.userId);
        friend.updateOnlineStatus(friendData.onlineStatus);
        this.sortFriendsListByOnlineStatus();
    }
    addFriendView(friend) {
        const isFriendInSameRoom = this.usersInRoom.includes(friend.userId);
        if (isFriendInSameRoom) return;
        const newFriend = new UIRoomFriendView(this.friendListContainer, friend.username, friend.onlineStatus, friend.icon, friend.userId);
        this.friendViews.push(newFriend);
        this.toggleEmptyFriendMessage(false);
        this.toggleRoomFullMessage(false);
        this.updateHeaderView(this.friendViews.length);
        this.sortFriendsListByOnlineStatus();
    }
    removeFriendView(friend) {
        ArrayUtils.removeElementFromArray(this.friendViews, friend);
        friend.remove();
        if (this.friendViews.length == 0) this.toggleEmptyFriendMessage(true);
        this.updateHeaderView(this.friendViews.length);
    }
    createEmptyFriendMessage() {
        const emptyFriendParentContainer = createDivIn(this.friendListContainer, 'room_friend_container');
        const emptyFriendMessageContainer = createDivIn(emptyFriendParentContainer, 'room_friend_empty_message_container');
        createSpanIn(emptyFriendMessageContainer, 'room_friend_empty_message_text', {
            key: 'strings:roomPage.noFriendsOnline'
        });
        this.emptyFriendMessage = emptyFriendParentContainer;
    }
    createLoginToAddFriendsMessage() {
        const loginForFriendsMessageContainer = createDivIn(this.friendListContainer, 'room_friend_container');
        const messageContainer = createDivIn(loginForFriendsMessageContainer, 'room_friend_empty_message_container room_friend_empty_message_container_login');
        createSpanIn(messageContainer, 'room_friend_empty_message_text', {
            key: 'strings:profilePage.friends.loginToAddFriends'
        });
        setElementOnClick(messageContainer, ()=>{
            new ViewPopupLogin();
        });
    }
    toggleEmptyFriendMessage(visible) {
        if (visible) this.toggleRoomFullMessage(false);
        if (this.emptyFriendMessage != undefined) {
            this.emptyFriendMessage.classList.toggle('hidden', !visible);
            return;
        }
        if (visible == false) return;
        this.createEmptyFriendMessage();
    }
    toggleRoomFullMessage(visible) {
        if (visible) this.toggleEmptyFriendMessage(false);
        if (this.roomFullMessage != undefined) {
            this.roomFullMessage.classList.toggle('hidden', !visible);
            return;
        }
        if (visible == false) return;
        this.createRoomFullMessage();
    }
    createRoomFullMessage() {
        const roomFullMessageContainer = createDivIn(this.friendListContainer, 'room_friend_container');
        createSpanIn(roomFullMessageContainer, 'room_friend_empty_message_text', {
            key: 'strings:roomPage.roomFull'
        });
        this.roomFullMessage = roomFullMessageContainer;
    }
    toggleFriendInviteButtonState(friendUserId, enable) {
        const friend = this.friendViews.find((friendView)=>friendView.getUserId() == friendUserId);
        if (friend == undefined) return;
        if (enable) {
            friend.enableInviteButton();
        } else {
            friend.disableInviteButton();
        }
    }
    sortFriendsListByOnlineStatus() {
        this.friendViews.sort((friendView1, friendView2)=>friendView1.getOnlineStatus() - friendView2.getOnlineStatus());
        for (const friend of this.friendViews)this.friendListContainer.removeChild(friend.getContainer());
        for (const friend of this.friendViews)this.friendListContainer.appendChild(friend.getContainer());
    }
    removeFriendViewWithDelay(friend, userId) {
        const removalTimeout = setTimeout(()=>this.removeFriendView(friend), this.FRIEND_REMOVAL_DELAY_MS);
        this.removalTimeouts.set(userId, removalTimeout);
    }
    deleteRemovalTimeout(userId) {
        const existingRemovalTimeout = this.removalTimeouts.get(userId);
        if (existingRemovalTimeout == undefined) return;
        this.removalTimeouts.delete(userId);
        clearTimeout(existingRemovalTimeout);
    }
    // eslint-disable-next-line class-methods-use-this
    animateInviteFriendsButton() {
        return;
    }
    constructor(friendListContainer, friendHeader, friendPlayerList){
        this.friendViews = [];
        this.removalTimeouts = new Map();
        this.FRIEND_REMOVAL_DELAY_MS = 1000;
        this.usersInRoom = [];
        this.friendList = [];
        this.isRoomFull = false;
        this.friendListContainer = friendListContainer;
        this.friendHeader = friendHeader;
        this.friendPlayerList = friendPlayerList;
        ClientUserState.registerChangeListener(()=>{
            this.showFriendListUI();
            void this.getAllFriendCount();
        });
    }
}
